// src/components/page-content-v4/hooks/usePageList.ts
import { useState, useEffect, useCallback } from 'react';
import { getPagesByTemplateId } from '@/services/pageService';
import { getTemplateById } from '@/services/templateService';
import { PageData, PaginationParams, Template } from '@/components/page-content-v4/types';

export const usePageList = (templateId: string | undefined) => {
  const [template, setTemplate] = useState<Template | null>(null);
  const [pages, setPages] = useState<PageData[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [pagination, setPagination] = useState<PaginationParams>({ page: 1, pageSize: 10 });
  const [totalItems, setTotalItems] = useState(0);

  const fetchPages = useCallback(async () => {
    if (!templateId) return;

    try {
      setIsLoading(true);

      // Fetch template
      const templateRes = await getTemplateById(templateId);
      const foundTemplate = templateRes.data;
      setTemplate(foundTemplate);

      if (!foundTemplate.isSinglePage) {
        // Only fetch pages for multi-page templates
        const response = await getPagesByTemplateId(templateId, pagination.page, pagination.pageSize);
        setPages(response.data.pages);
        setTotalItems(response.data.totalItems);
      }
    } catch (err: any) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [templateId, pagination]);

  useEffect(() => {
    fetchPages();
  }, [fetchPages]);

  return {
    template,
    pages,
    isLoading,
    error,
    pagination,
    setPagination,
    totalItems,
    refreshPages: fetchPages,
  };
};
